import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './IconCard.module.css';

const BRAND_AMEX = 'amex';
const BRAND_DINERS = 'diners';
const BRAND_DISCOVERY = 'discovery';
const BRAND_JCB = 'jcb';
const BRAND_MASTERCARD = 'mastercard';
const BRAND_UNIONPAY = 'unionpay';
const BRAND_VISA = 'visa';
const INFO = 'info';
const PROJECT = 'project';
const MATCHED = 'matched';
const QUOTES = 'quotes';
const CHAT = 'chat';
const MANAGEMENT = 'management';
const REVIEW = 'review';
const SEARCH = 'search';
const FACEBOOK = 'facebook';
const TWITTER = 'twitter';
const LINKEDIN = 'linkedin';
const INSTAGRAM = 'instagram';
const LINK = 'link';
const SHARE = 'share';
const CHECKED = 'checked';
const LOCATION = 'location';
const PROFILE = 'profile';
const STAR = 'star';
const FLEXIBLE = 'flexible';
const MAP = 'map';
const OCCUPIED = 'occupied';
const EDIT = 'edit';
const BOTTOMARROW = 'bottomarrow';
const TOPARROW = 'toparrow';
const VERTICALDOT = 'verticaldot';
const NEXTARROW = 'nextarrow';
const OPENARROW = 'openarrow';
const CLOSEARROW = 'closearrow';
const MESSAGE = 'message';
const LOGS = 'logs';
const INFORMATION = 'information';
const DOWNARROW = 'downarrow';
const UPARROW = 'uparrow';
const PIN = 'pin';
const FILTERICON = 'filtericon';
const BLACKDOT = 'blackdot';
const BILLEDIT = 'billedit';
const TRASH = 'trash';
const CLOSE = 'close';
const RIGHTARROW = 'rightarrow';
const WARNING = 'waring';
const PHONEICONS = 'phoneIcon';
const MENU = 'menu';
const PAGINATIONLEFT = 'paginationleft';
const PAGINATIONRIGHT = 'paginationright';
const CLEARFILTERS = 'clearFilters';
const RESETFILTER = 'resetfilter';
const CALENDER = 'calender';
const DAILYLOG = 'dailylog';
const PROSNETWORK = 'prosnetwork';
const PROJECTBIDDING = 'projectbidding';
const PROJECTMANAGEMENT = 'projectmanagement';
const PLUS = 'plus';
const MINUS = 'minus';
const CARDLOCATION = 'cardlocation';

const IconCard = props => {
  const { className, rootClassName, brand } = props;
  const classes = classNames(rootClassName || css.root, className);

  switch (brand) {
    case CARDLOCATION:
      return (
        <svg
          width="15"
          height="19"
          viewBox="0 0 15 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 7.90918C14 13.505 8.99356 16.6436 7.76794 17.33C7.60168 17.4232 7.3976 17.4232 7.23133 17.33C6.00572 16.6429 1 13.5036 1 7.90918C1 4.38836 3.91015 1.53418 7.5 1.53418C11.0899 1.53418 14 4.38836 14 7.90918Z"
            fill="#3D3C45"
            stroke="#3D3C45"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <ellipse
            cx="7.5"
            cy="7.90918"
            rx="3.25"
            ry="3.1875"
            fill="#FEFEFE"
            stroke="#3D3C45"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      );
    case MINUS:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.57271 7.67773L0.496006 1.60104C0.349493 1.45452 0.267183 1.25581 0.267183 1.04861C0.267183 0.841408 0.349494 0.642694 0.496006 0.496181C0.642519 0.349669 0.841233 0.267358 1.04843 0.267358C1.25563 0.267358 1.45435 0.349668 1.60086 0.496181L7.67756 6.57288L13.7543 0.496181C13.9008 0.349668 14.0995 0.267358 14.3067 0.267358C14.5139 0.267358 14.7126 0.349669 14.8591 0.496181C15.0056 0.642694 15.0879 0.841408 15.0879 1.04861C15.0879 1.25581 15.0056 1.45452 14.8591 1.60104L8.78241 7.67773L14.8591 13.7544C15.0056 13.9009 15.0879 14.0997 15.0879 14.3069C15.0879 14.5141 15.0056 14.7128 14.8591 14.8593C14.7126 15.0058 14.5139 15.0881 14.3067 15.0881C14.0995 15.0881 13.9008 15.0058 13.7543 14.8593L7.67756 8.78259L1.60086 14.8593C1.45435 15.0058 1.25563 15.0881 1.04843 15.0881C0.841233 15.0881 0.642519 15.0058 0.496006 14.8593C0.349494 14.7128 0.267183 14.5141 0.267183 14.3069C0.267183 14.0997 0.349493 13.9009 0.496006 13.7544L6.57271 7.67773Z"
            fill="#484133"
          />
        </svg>
      );
    case PLUS:
      return (
        <svg
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.71875 9.71875V1.125C9.71875 0.9178 9.80106 0.719086 9.94757 0.572573C10.0941 0.42606 10.2928 0.34375 10.5 0.34375C10.7072 0.34375 10.9059 0.42606 11.0524 0.572573C11.1989 0.719086 11.2812 0.9178 11.2812 1.125V9.71875H19.875C20.0822 9.71875 20.2809 9.80106 20.4274 9.94757C20.5739 10.0941 20.6562 10.2928 20.6562 10.5C20.6562 10.7072 20.5739 10.9059 20.4274 11.0524C20.2809 11.1989 20.0822 11.2812 19.875 11.2812H11.2812V19.875C11.2812 20.0822 11.1989 20.2809 11.0524 20.4274C10.9059 20.5739 10.7072 20.6562 10.5 20.6562C10.2928 20.6562 10.0941 20.5739 9.94757 20.4274C9.80106 20.2809 9.71875 20.0822 9.71875 19.875V11.2812H1.125C0.9178 11.2812 0.719086 11.1989 0.572573 11.0524C0.42606 10.9059 0.34375 10.7072 0.34375 10.5C0.34375 10.2928 0.42606 10.0941 0.572573 9.94757C0.719086 9.80106 0.9178 9.71875 1.125 9.71875H9.71875Z"
            fill="#484133"
          />
        </svg>
      );
    case PROJECTMANAGEMENT:
      return (
        <svg
          width="45"
          height="46"
          viewBox="0 0 45 46"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.6551 24.9165C17.164 26.0656 16.887 27.3319 16.8754 28.663L16.875 28.75V40.25H5.625V32.5834C5.625 28.3898 8.91448 24.9854 13.001 24.9177L13.125 24.9166L17.6551 24.9165ZM31.8749 21.0834C36.0172 21.0834 39.375 24.5158 39.375 28.75V40.25H18.75V28.75C18.75 24.5158 22.1078 21.0834 26.25 21.0834H31.8749ZM15 11.5C18.1013 11.5 20.625 14.0799 20.625 17.25C20.625 20.4201 18.1013 23 15 23C11.8988 23 9.37503 20.4201 9.37503 17.25C9.37503 14.0799 11.8988 11.5 15 11.5ZM29.0625 5.75C32.6813 5.75 35.6251 8.75914 35.6251 12.4584C35.6251 16.1576 32.6813 19.1666 29.0626 19.1666C25.4438 19.1666 22.5001 16.1575 22.5001 12.4584C22.5 8.75914 25.4437 5.75 29.0625 5.75Z"
            fill="#3D3C45"
          />
        </svg>
      );
    case PROJECTBIDDING:
      return (
        <svg
          width="44"
          height="45"
          viewBox="0 0 44 45"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M39.5999 12.9375C39.5999 12.4899 39.4261 12.0607 39.1166 11.7443C38.8072 11.4278 38.3875 11.25 37.9499 11.25H6.0499C5.6123 11.25 5.19261 11.4278 4.88318 11.7443C4.57374 12.0607 4.3999 12.4899 4.3999 12.9375C4.3999 13.3851 4.57374 13.8143 4.88318 14.1307C5.19261 14.4472 5.6123 14.625 6.0499 14.625H37.9499C38.3875 14.625 38.8072 14.4472 39.1166 14.1307C39.4261 13.8143 39.5999 13.3851 39.5999 12.9375ZM39.5999 19.6875C39.5999 19.2399 39.4261 18.8107 39.1166 18.4943C38.8072 18.1778 38.3875 18 37.9499 18H6.0499C5.6123 18 5.19261 18.1778 4.88318 18.4943C4.57374 18.8107 4.3999 19.2399 4.3999 19.6875C4.3999 20.1351 4.57374 20.5643 4.88318 20.8807C5.19261 21.1972 5.6123 21.375 6.0499 21.375H26.8531C28.4366 20.6329 30.1581 20.2491 31.8999 20.25C33.6417 20.2491 35.3632 20.6329 36.9467 21.375H37.9499C38.3875 21.375 38.8072 21.1972 39.1166 20.8807C39.4261 20.5643 39.5999 20.1351 39.5999 19.6875ZM19.8483 31.5C19.7505 32.6269 19.8016 33.7621 20.0001 34.875H6.0499C5.6123 34.875 5.19261 34.6972 4.88318 34.3807C4.57374 34.0643 4.3999 33.6351 4.3999 33.1875C4.3999 32.74 4.57374 32.3107 4.88318 31.9943C5.19261 31.6778 5.6123 31.5 6.0499 31.5H19.8483ZM22.5653 24.75C21.7475 25.7626 21.0925 26.9018 20.6249 28.125H6.0499C5.6123 28.125 5.19261 27.9472 4.88318 27.6307C4.57374 27.3143 4.3999 26.8851 4.3999 26.4375C4.3999 25.9899 4.57374 25.5607 4.88318 25.2443C5.19261 24.9278 5.6123 24.75 6.0499 24.75H22.5653ZM41.7999 32.625C41.7999 29.9397 40.7569 27.3644 38.9003 25.4655C37.0436 23.5667 34.5255 22.5 31.8999 22.5C29.2743 22.5 26.7562 23.5667 24.8995 25.4655C23.0429 27.3644 21.9999 29.9397 21.9999 32.625C21.9999 35.3103 23.0429 37.8857 24.8995 39.7845C26.7562 41.6833 29.2743 42.75 31.8999 42.75C34.5255 42.75 37.0436 41.6833 38.9003 39.7845C40.7569 37.8857 41.7999 35.3103 41.7999 32.625ZM36.2999 28.125C36.4986 27.93 36.7616 27.8182 37.037 27.8119C37.3123 27.8056 37.5799 27.9052 37.787 28.0909C37.994 28.2766 38.1254 28.5351 38.1552 28.8151C38.1849 29.0951 38.1109 29.3764 37.9477 29.6033L37.8157 29.7563L30.0893 37.9463C29.8935 38.1369 29.6358 38.2472 29.3655 38.2559C29.0953 38.2646 28.8313 38.1712 28.6241 37.9935L28.4767 37.8428L25.5287 34.1415C25.3537 33.9238 25.2649 33.6469 25.2799 33.3655C25.2949 33.0841 25.4127 32.8187 25.6099 32.6218C25.8071 32.425 26.0693 32.311 26.3448 32.3024C26.6202 32.2938 26.8888 32.3913 27.0973 32.5755L27.2359 32.7195L29.4337 35.4803L36.2999 28.125Z"
            fill="#3D3C45"
          />
        </svg>
      );
    case PROSNETWORK:
      return (
        <svg width="40" height="39" viewBox="0 0 40 39" fill="none">
          <path
            d="M30.0002 3.25H11.6668C9.8285 3.25 8.3335 4.70762 8.3335 6.5V11.375C8.3335 13.1674 9.8285 14.625 11.6668 14.625H30.0002C31.8385 14.625 33.3335 13.1674 33.3335 11.375V6.5C33.3335 4.70762 31.8385 3.25 30.0002 3.25Z"
            fill="#3D3C45"
          />
          <path
            d="M21.6668 24.375V21.125C21.6668 19.3326 20.1718 17.875 18.3335 17.875H6.66683V8.125C4.8285 8.125 3.3335 9.58262 3.3335 11.375V17.875C3.3335 19.6674 4.8285 21.125 6.66683 21.125H18.3335V24.375C17.8915 24.375 17.4675 24.5462 17.155 24.851C16.8424 25.1557 16.6668 25.569 16.6668 26V34.125C16.6668 34.556 16.8424 34.9693 17.155 35.274C17.4675 35.5788 17.8915 35.75 18.3335 35.75H21.6668C22.1089 35.75 22.5328 35.5788 22.8453 35.274C23.1579 34.9693 23.3335 34.556 23.3335 34.125V26C23.3335 25.569 23.1579 25.1557 22.8453 24.851C22.5328 24.5462 22.1089 24.375 21.6668 24.375Z"
            fill="#3D3C45"
          />
        </svg>
      );
    case DAILYLOG:
      return (
        <svg width="43" height="43" viewBox="0 0 43 43" fill="none">
          <mask id="mask0_1947_1540" maskUnits="userSpaceOnUse" x="5" y="2" width="33" height="39">
            <path
              d="M11.6458 8.95837H36.7291V39.4167H11.6458V8.95837Z"
              fill="white"
              stroke="white"
              stroke-width="2"
              stroke-linejoin="round"
            />
            <path
              fill="none"
              d="M31.3541 8.95837V3.58337H7.16659C6.929 3.58337 6.70114 3.67776 6.53314 3.84576C6.36513 4.01376 6.27075 4.24162 6.27075 4.47921V34.0417H11.6458"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M18.8125 19.7084H29.5625M18.8125 26.875H29.5625"
              stroke="black"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </mask>
          <g mask="url(#mask0_1947_1540)">
            <path d="M0 0H43V43H0V0Z" fill="#3D3C45" />
          </g>
        </svg>
      );
    case CALENDER:
      return (
        <svg
          width="19"
          height="19"
          viewBox="0 0 19 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.13505 1.97925C6.13505 1.82178 6.07249 1.67075 5.96114 1.5594C5.84979 1.44805 5.69877 1.3855 5.5413 1.3855C5.38383 1.3855 5.2328 1.44805 5.12145 1.5594C5.01011 1.67075 4.94755 1.82178 4.94755 1.97925V3.23008C3.80755 3.32112 3.06022 3.54437 2.5108 4.09458C1.96059 4.644 1.73734 5.39212 1.64551 6.53133H17.3538C17.2619 5.39133 17.0387 4.644 16.4885 4.09458C15.939 3.54437 15.1909 3.32112 14.0517 3.22929V1.97925C14.0517 1.82178 13.9892 1.67075 13.8778 1.5594C13.7665 1.44805 13.6154 1.3855 13.458 1.3855C13.3005 1.3855 13.1495 1.44805 13.0381 1.5594C12.9268 1.67075 12.8642 1.82178 12.8642 1.97925V3.17704C12.3378 3.16675 11.7472 3.16675 11.083 3.16675H7.9163C7.25209 3.16675 6.66151 3.16675 6.13505 3.17704V1.97925Z"
            fill="#F15B26"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.58301 9.5C1.58301 8.83579 1.58301 8.24521 1.5933 7.71875H17.406C17.4163 8.24521 17.4163 8.83579 17.4163 9.5V11.0833C17.4163 14.0687 17.4163 15.5618 16.4885 16.4888C15.5607 17.4159 14.0684 17.4167 11.083 17.4167H7.91634C4.93097 17.4167 3.43788 17.4167 2.51084 16.4888C1.5838 15.561 1.58301 14.0687 1.58301 11.0833V9.5ZM13.458 11.0833C13.668 11.0833 13.8693 10.9999 14.0178 10.8515C14.1663 10.703 14.2497 10.5016 14.2497 10.2917C14.2497 10.0817 14.1663 9.88034 14.0178 9.73187C13.8693 9.58341 13.668 9.5 13.458 9.5C13.248 9.5 13.0467 9.58341 12.8982 9.73187C12.7497 9.88034 12.6663 10.0817 12.6663 10.2917C12.6663 10.5016 12.7497 10.703 12.8982 10.8515C13.0467 10.9999 13.248 11.0833 13.458 11.0833ZM13.458 14.25C13.668 14.25 13.8693 14.1666 14.0178 14.0181C14.1663 13.8697 14.2497 13.6683 14.2497 13.4583C14.2497 13.2484 14.1663 13.047 14.0178 12.8985C13.8693 12.7501 13.668 12.6667 13.458 12.6667C13.248 12.6667 13.0467 12.7501 12.8982 12.8985C12.7497 13.047 12.6663 13.2484 12.6663 13.4583C12.6663 13.6683 12.7497 13.8697 12.8982 14.0181C13.0467 14.1666 13.248 14.25 13.458 14.25ZM10.2913 10.2917C10.2913 10.5016 10.2079 10.703 10.0595 10.8515C9.911 10.9999 9.70964 11.0833 9.49967 11.0833C9.28971 11.0833 9.08835 10.9999 8.93988 10.8515C8.79142 10.703 8.70801 10.5016 8.70801 10.2917C8.70801 10.0817 8.79142 9.88034 8.93988 9.73187C9.08835 9.58341 9.28971 9.5 9.49967 9.5C9.70964 9.5 9.911 9.58341 10.0595 9.73187C10.2079 9.88034 10.2913 10.0817 10.2913 10.2917ZM10.2913 13.4583C10.2913 13.6683 10.2079 13.8697 10.0595 14.0181C9.911 14.1666 9.70964 14.25 9.49967 14.25C9.28971 14.25 9.08835 14.1666 8.93988 14.0181C8.79142 13.8697 8.70801 13.6683 8.70801 13.4583C8.70801 13.2484 8.79142 13.047 8.93988 12.8985C9.08835 12.7501 9.28971 12.6667 9.49967 12.6667C9.70964 12.6667 9.911 12.7501 10.0595 12.8985C10.2079 13.047 10.2913 13.2484 10.2913 13.4583ZM5.54134 11.0833C5.7513 11.0833 5.95267 10.9999 6.10113 10.8515C6.2496 10.703 6.33301 10.5016 6.33301 10.2917C6.33301 10.0817 6.2496 9.88034 6.10113 9.73187C5.95267 9.58341 5.7513 9.5 5.54134 9.5C5.33138 9.5 5.13001 9.58341 4.98155 9.73187C4.83308 9.88034 4.74967 10.0817 4.74967 10.2917C4.74967 10.5016 4.83308 10.703 4.98155 10.8515C5.13001 10.9999 5.33138 11.0833 5.54134 11.0833ZM5.54134 14.25C5.7513 14.25 5.95267 14.1666 6.10113 14.0181C6.2496 13.8697 6.33301 13.6683 6.33301 13.4583C6.33301 13.2484 6.2496 13.047 6.10113 12.8985C5.95267 12.7501 5.7513 12.6667 5.54134 12.6667C5.33138 12.6667 5.13001 12.7501 4.98155 12.8985C4.83308 13.047 4.74967 13.2484 4.74967 13.4583C4.74967 13.6683 4.83308 13.8697 4.98155 14.0181C5.13001 14.1666 5.33138 14.25 5.54134 14.25Z"
            fill="#F15B26"
          />
        </svg>
      );
    case RESETFILTER:
      return (
        <svg fill="#000000" width="20px" height="20px" viewBox="0 0 48 48">
          <path
            d="M24 0v5.333c10.291 0 18.667 8.373 18.667 18.667S34.291 42.667 24 42.667 5.333 34.293 5.333 24c0 -4.925 1.96 -9.563 5.333 -13.019v6.352H16V2.667H1.333V8h4.776C2.216 12.352 0 18.024 0 24c0 13.232 10.765 24 24 24s24 -10.768 24 -24S37.235 0 24 0"
            fillRule="evenodd"
          />
        </svg>
      );
    case CLEARFILTERS:
      return (
        <svg
          fill="#000000"
          width="20px"
          height="20px"
          viewBox="-0.15 -0.15 0.6 0.6"
          preserveAspectRatio="xMinYMin"
          class="jam jam-close"
        >
          <path d="m0.183 0.148 0.088 -0.088A0.025 0.025 0 1 0 0.236 0.024L0.147 0.112 0.059 0.024A0.025 0.025 0 1 0 0.024 0.059l0.088 0.088L0.024 0.236a0.025 0.025 0 1 0 0.035 0.035l0.088 -0.088 0.088 0.088a0.025 0.025 0 1 0 0.035 -0.035L0.183 0.147z" />
        </svg>
      );
    case PAGINATIONRIGHT:
      return (
        <svg
          width="9"
          height="13"
          viewBox="0 0 9 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.599942 13C0.429541 13 0.26094 12.935 0.141539 12.8077C-0.0720627 12.5802 -0.0402625 12.2384 0.212339 12.0445L7.47059 6.49995L0.212339 0.955407C-0.0402625 0.761489 -0.0720627 0.419695 0.141539 0.191652C0.35634 -0.0369336 0.734343 -0.0645588 0.987545 0.127734L8.7876 6.08611C8.9226 6.18957 9 6.3407 9 6.49995C9 6.6592 8.9226 6.81033 8.7876 6.91379L0.987545 12.8722C0.874744 12.9577 0.736743 13 0.599942 13Z"
            fill="#0E1319"
          />
          <path
            d="M0.599942 13C0.429541 13 0.26094 12.935 0.141539 12.8077C-0.0720627 12.5802 -0.0402625 12.2384 0.212339 12.0445L7.47059 6.49995L0.212339 0.955407C-0.0402625 0.761489 -0.0720627 0.419695 0.141539 0.191652C0.35634 -0.0369336 0.734343 -0.0645588 0.987545 0.127734L8.7876 6.08611C8.9226 6.18957 9 6.3407 9 6.49995C9 6.6592 8.9226 6.81033 8.7876 6.91379L0.987545 12.8722C0.874744 12.9577 0.736743 13 0.599942 13"
            stroke="#0E1319"
          />
        </svg>
      );
    case PAGINATIONLEFT:
      return (
        <svg
          width="9"
          height="13"
          viewBox="0 0 9 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.40006 0C8.57046 0 8.73906 0.0650005 8.85846 0.192293C9.07206 0.419795 9.04026 0.761589 8.78766 0.955507L1.52941 6.50005L8.78766 12.0446C9.04026 12.2385 9.07206 12.5803 8.85846 12.8083C8.64366 13.0369 8.26566 13.0646 8.01246 12.8723L0.212401 6.91389C0.0774002 6.81043 0 6.6593 0 6.50005C0 6.3408 0.0774002 6.18967 0.212401 6.08621L8.01246 0.127834C8.12526 0.0422506 8.26326 0 8.40006 0Z"
            fill="#0E1319"
          />
          <path
            d="M8.40006 0C8.57046 0 8.73906 0.0650005 8.85846 0.192293C9.07206 0.419795 9.04026 0.761589 8.78766 0.955507L1.52941 6.50005L8.78766 12.0446C9.04026 12.2385 9.07206 12.5803 8.85846 12.8083C8.64366 13.0369 8.26566 13.0646 8.01246 12.8723L0.212401 6.91389C0.0774005 6.81043 0 6.6593 0 6.50005C0 6.3408 0.0774005 6.18967 0.212401 6.08621L8.01246 0.127834C8.12526 0.0422503 8.26326 0 8.40006 0"
            stroke="#0E1319"
          />
        </svg>
      );
    case MENU:
      return (
        <svg width="26" height="12" viewBox="0 0 26 12" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <filter
              x="-38.9%"
              y="-125%"
              width="177.8%"
              height="450%"
              filterUnits="objectBoundingBox"
            >
              <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
              <feGaussianBlur
                stdDeviation="2"
                in="shadowOffsetOuter1"
                result="shadowBlurOuter1"
              ></feGaussianBlur>
              <feColorMatrix
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
                in="shadowBlurOuter1"
              ></feColorMatrix>
            </filter>
          </defs>
          <g transform="translate(-342 -18)" filter="url(#a)">
            <path d="M348 24c-1.105 0-2-.895-2-2s.895-2 2-2 2 .895 2 2-.895 2-2 2zm7 0c-1.105 0-2-.895-2-2s.895-2 2-2 2 .895 2 2-.895 2-2 2zm7 0c-1.105 0-2-.895-2-2s.895-2 2-2 2 .895 2 2-.895 2-2 2z"></path>
          </g>
          <g transform="translate(-342 -18)">
            <path d="M348 24c-1.105 0-2-.895-2-2s.895-2 2-2 2 .895 2 2-.895 2-2 2zm7 0c-1.105 0-2-.895-2-2s.895-2 2-2 2 .895 2 2-.895 2-2 2zm7 0c-1.105 0-2-.895-2-2s.895-2 2-2 2 .895 2 2-.895 2-2 2z"></path>
          </g>
        </svg>
      );
    case PHONEICONS:
      return (
        <svg
          className={className}
          xmlns="http://www.w3.org/2000/svg"
          height="22"
          width="22"
          viewBox="0 0 24 24"
        >
          <path
            d="M8.76 13a3.19 3.19 0 0 0 4-.44l.45-.44a1.08 1.08 0 0 0 0-1.51L11.3 8.72a1.07 1.07 0 0 0-1.5 0h0a1.08 1.08 0 0 1-1.51 0l-3-3a1.06 1.06 0 0 1 0-1.51h0a1.07 1.07 0 0 0 0-1.5L3.39.81a1.08 1.08 0 0 0-1.51 0l-.44.45a3.19 3.19 0 0 0-.44 4A28.94 28.94 0 0 0 8.76 13Z"
            style={{
              fill: 'none',
              stroke: '#656464',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
            }}
            transform="scale(1.71429)"
          />
        </svg>
      );
    case RIGHTARROW:
      return (
        <svg
          class="Button_arrowButtonIcon__2663h"
          width="14"
          height="12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.5 6h11M8 1.5L12.5 6 8 10.5"
            stroke="#fff"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </svg>
      );
    case WARNING:
      return (
        <svg
          className={classes}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          height="24"
          width="24"
        >
          <g transform="scale(2.28571)">
            <circle
              cx="7"
              cy="7"
              r="6.5"
              style={{
                fill: 'none',
                stroke: '#ff0000',
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeWidth: '1',
              }}
            />
            <path
              style={{
                fill: 'none',
                stroke: '#ff0000',
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeWidth: '0.9',
              }}
              d="M7 3.5v3"
            />
            <circle
              cx="7"
              cy="9.5"
              r="0.5"
              style={{
                fill: 'none',
                stroke: '#ff0000',
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeWidth: '0.9',
              }}
            />
          </g>
        </svg>
      );
    case CLOSE:
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.175 15.4502C17.4039 15.6792 17.5325 15.9897 17.5325 16.3135C17.5325 16.6373 17.4039 16.9478 17.175 17.1768C16.946 17.4057 16.6355 17.5344 16.3117 17.5344C15.9879 17.5344 15.6774 17.4057 15.4484 17.1768L9.0002 10.7266L2.54997 17.1748C2.32101 17.4037 2.01048 17.5323 1.68668 17.5323C1.36289 17.5323 1.05236 17.4037 0.823403 17.1748C0.594447 16.9458 0.46582 16.6353 0.46582 16.3115C0.46582 15.9877 0.594447 15.6772 0.823403 15.4482L7.27364 9L0.825434 2.54976C0.596478 2.3208 0.467852 2.01027 0.467852 1.68648C0.467852 1.36269 0.596478 1.05215 0.825434 0.823198C1.05439 0.594242 1.36492 0.465615 1.68872 0.465615C2.01251 0.465615 2.32304 0.594242 2.552 0.823198L9.0002 7.27343L15.4504 0.822182C15.6794 0.593226 15.9899 0.4646 16.3137 0.4646C16.6375 0.4646 16.948 0.593226 17.177 0.822182C17.406 1.05114 17.5346 1.36167 17.5346 1.68546C17.5346 2.00926 17.406 2.31979 17.177 2.54875L10.7268 9L17.175 15.4502Z"
            fill="#F15B26"
          />
        </svg>
      );
    case TRASH:
      return (
        <svg
          width="13"
          height="17"
          viewBox="0 0 13 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.25 14.625C1.25 15.5875 2.0375 16.375 3 16.375H10C10.9625 16.375 11.75 15.5875 11.75 14.625V4.125H1.25V14.625ZM12.625 1.5H9.5625L8.6875 0.625H4.3125L3.4375 1.5H0.375V3.25H12.625V1.5Z"
            fill="#2B3740"
          />
        </svg>
      );
    case BILLEDIT:
      return (
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.625 13.0937V16.3749H3.90625L13.5837 6.69744L10.3025 3.41619L0.625 13.0937ZM16.1212 4.15994C16.2024 4.07899 16.2667 3.98284 16.3106 3.87699C16.3545 3.77114 16.3771 3.65766 16.3771 3.54307C16.3771 3.42847 16.3545 3.315 16.3106 3.20915C16.2667 3.10329 16.2024 3.00714 16.1212 2.92619L14.0738 0.878691C13.9928 0.797576 13.8966 0.733222 13.7908 0.689313C13.6849 0.645404 13.5715 0.622803 13.4569 0.622803C13.3423 0.622803 13.2288 0.645404 13.123 0.689313C13.0171 0.733222 12.9209 0.797576 12.84 0.878691L11.2388 2.47994L14.52 5.76119L16.1212 4.15994Z"
            fill="#2B3740"
          />
        </svg>
      );
    case BLACKDOT:
      return (
        <svg
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="5" cy="5" r="5" fill="#2B3740" />
        </svg>
      );
    case FILTERICON:
      return (
        <svg
          width="29"
          height="29"
          viewBox="0 0 29 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.7344 9.51562H2.26562C1.9051 9.51562 1.55933 9.37241 1.3044 9.11747C1.04947 8.86254 0.90625 8.51678 0.90625 8.15625C0.90625 7.79572 1.04947 7.44996 1.3044 7.19503C1.55933 6.94009 1.9051 6.79688 2.26562 6.79688H26.7344C27.0949 6.79688 27.4407 6.94009 27.6956 7.19503C27.9505 7.44996 28.0938 7.79572 28.0938 8.15625C28.0938 8.51678 27.9505 8.86254 27.6956 9.11747C27.4407 9.37241 27.0949 9.51562 26.7344 9.51562ZM22.2031 15.8594H6.79688C6.43635 15.8594 6.09058 15.7162 5.83565 15.4612C5.58072 15.2063 5.4375 14.8605 5.4375 14.5C5.4375 14.1395 5.58072 13.7937 5.83565 13.5388C6.09058 13.2838 6.43635 13.1406 6.79688 13.1406H22.2031C22.5637 13.1406 22.9094 13.2838 23.1643 13.5388C23.4193 13.7937 23.5625 14.1395 23.5625 14.5C23.5625 14.8605 23.4193 15.2063 23.1643 15.4612C22.9094 15.7162 22.5637 15.8594 22.2031 15.8594ZM16.7656 22.2031H12.2344C11.8738 22.2031 11.5281 22.0599 11.2732 21.805C11.0182 21.55 10.875 21.2043 10.875 20.8438C10.875 20.4832 11.0182 20.1375 11.2732 19.8825C11.5281 19.6276 11.8738 19.4844 12.2344 19.4844H16.7656C17.1262 19.4844 17.4719 19.6276 17.7268 19.8825C17.9818 20.1375 18.125 20.4832 18.125 20.8438C18.125 21.2043 17.9818 21.55 17.7268 21.805C17.4719 22.0599 17.1262 22.2031 16.7656 22.2031Z"
            fill="black"
          />
        </svg>
      );
    case PIN:
      return (
        <svg
          width="12"
          height="20"
          viewBox="0 0 12 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.87677 20C4.32361 20 3.00681 19.4667 1.92635 18.4C0.845893 17.3333 0.305664 16.0333 0.305664 14.5V4C0.305664 2.9 0.702395 1.95833 1.49586 1.175C2.28932 0.391667 3.24316 0 4.35738 0C5.4716 0 6.42544 0.391667 7.2189 1.175C8.01236 1.95833 8.40909 2.9 8.40909 4V13.5C8.40909 14.2 8.1643 14.7917 7.67472 15.275C7.18514 15.7583 6.58582 16 5.87677 16C5.16772 16 4.56841 15.7583 4.07882 15.275C3.58924 14.7917 3.34445 14.2 3.34445 13.5V4H4.86384V13.5C4.86384 13.7833 4.96092 14.0208 5.15506 14.2125C5.34921 14.4042 5.58978 14.5 5.87677 14.5C6.16377 14.5 6.40434 14.4042 6.59848 14.2125C6.79263 14.0208 6.8897 13.7833 6.8897 13.5V4C6.8897 3.3 6.64491 2.70833 6.15533 2.225C5.66575 1.74167 5.06643 1.5 4.35738 1.5C3.64833 1.5 3.04901 1.74167 2.55943 2.225C2.06985 2.70833 1.82506 3.3 1.82506 4V14.5C1.82506 15.6 2.22179 16.5417 3.01525 17.325C3.80871 18.1083 4.76255 18.5 5.87677 18.5C6.99099 18.5 7.94483 18.1083 8.7383 17.325C9.53176 16.5417 9.92849 15.6 9.92849 14.5V4H11.4479V14.5C11.4479 16.0333 10.9077 17.3333 9.82719 18.4C8.74674 19.4667 7.42993 20 5.87677 20Z"
            fill="#F15B26"
          />
        </svg>
      );
    case UPARROW:
      return (
        <svg
          width="14"
          height="11"
          viewBox="0 0 14 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 11L14 11L7 -3.0598e-07L0 11Z" fill="black" />
        </svg>
      );
    case DOWNARROW:
      return (
        <svg
          width="14"
          height="11"
          viewBox="0 0 14 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M14 0L0 -6.11959e-07L7 11L14 0Z" fill="black" />
        </svg>
      );
    case TOPARROW:
      return (
        <svg
          width="14"
          height="11"
          viewBox="0 0 14 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M14 0L0 -6.11959e-07L7 11L14 0Z" fill="black" />
        </svg>
      );
    case VERTICALDOT:
      return (
        <svg
          width="4"
          height="18"
          viewBox="0 0 4 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 14C3.10457 14 4 14.8954 4 16C4 17.1046 3.10457 18 2 18C0.895431 18 -4.12575e-08 17.1046 -9.21522e-08 16C-1.43047e-07 14.8954 0.89543 14 2 14ZM2 7C3.10457 7 4 7.89543 4 9C4 10.1046 3.10457 11 2 11C0.89543 11 -3.63794e-07 10.1046 -4.14689e-07 9C-4.65584e-07 7.89543 0.89543 7 2 7ZM4 2C4 0.895429 3.10457 -1.28739e-07 2 -8.29352e-08C0.89543 -3.71314e-08 -7.8812e-07 0.89543 -7.37225e-07 2C-6.8633e-07 3.10457 0.89543 4 2 4C3.10457 4 4 3.10457 4 2Z"
            fill="black"
          />
        </svg>
      );
    case BOTTOMARROW:
      return (
        <svg
          width="14"
          height="11"
          viewBox="0 0 14 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 11L14 11L7 -3.0598e-07L0 11Z" fill="black" />
        </svg>
      );
    case INFORMATION:
      return (
        <svg width="22" height="22" fill="none" viewBox="0 0 46 47">
          <g fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
            <path stroke="#b2b2b2" strokeWidth="2.75" d="M8 45h32V2H8z"></path>
            <path
              stroke="#b2b2b2"
              d="M8 2H4c-1.1 0-2 .84-2 1.87v39.26C2 44.16 2.9 45 4 45h4"
              strokeWidth="2.5"
            ></path>
            <path
              stroke="#b2b2b2"
              d="M26.35 24v2.77l4.822 1.34c1.005.278 1.828 1.336 1.828 2.352V36H14v-5.538c0-1.016.823-2.074 1.826-2.352l4.824-1.34V24M29 18c0 3.315-2.464 6-5.5 6-3.038 0-5.5-2.685-5.5-6 0-3.313 2.462-6 5.5-6 3.036 0 5.5 2.687 5.5 6z"
              strokeWidth="2"
            ></path>
            <path
              stroke="#b2b2b2"
              d="M28.5 17.01c-.847 1-3.27.996-4.183-1.01-1.694 2-4.447 2-5.817.858M41 5h1.333C43.8 5 45 6.62 45 8.6V14h-4M41 14h4v9h-4M41 23h4v10h-4M41 33h4v5.4c0 1.98-1.2 3.6-2.667 3.6H41"
              strokeWidth="1.5"
            ></path>
          </g>
        </svg>
      );
    case LOGS:
      return (
        <svg fill="none" width="22" height="22" viewBox="0 0 22 22">
          <g clipPath="url(#clip0_908_395)">
            <path
              d="M6.28571 5.49999V0.785706"
              stroke="#4a4a4a"
              strokeWidth="1.71429"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
            <path
              d="M11 5.49999V0.785706"
              stroke="#4a4a4a"
              strokeWidth="1.71429"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
            <path
              d="M15.7143 5.49999V0.785706"
              stroke="#4a4a4a"
              strokeWidth="1.71429"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
            <path
              fill="none"
              d="M19.6428 3.14282H2.35713C1.48926 3.14282 0.785706 3.84637 0.785706 4.71425V19.6428C0.785706 20.5107 1.48926 21.2143 2.35713 21.2143H19.6428C20.5107 21.2143 21.2143 20.5107 21.2143 19.6428V4.71425C21.2143 3.84637 20.5107 3.14282 19.6428 3.14282Z"
              stroke="#4a4a4a"
              strokeWidth="1.71429"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
            <path
              d="M5.5 11H16.5"
              stroke="#4a4a4a"
              strokeWidth="1.71429"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
            <path
              d="M5.5 15.7143H11.7857"
              stroke="#4a4a4a"
              strokeWidth="1.71429"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
          </g>
          <defs>
            <clipPath id="clip0_908_395">
              <rect width="22" height="22" fill="white"></rect>
            </clipPath>
          </defs>
        </svg>
      );
    case MESSAGE:
      return (
        <svg fill="none" width="22" height="22" viewBox="0 0 22 22">
          <g clipPath="url(#clip0_908_383)">
            <path
              fill="none"
              d="M0.785706 2.75H21.2143V19.25H0.785706V2.75Z"
              stroke="#4a4a4a"
              strokeWidth="1.71429"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
            <path
              fill="none"
              d="M0.785706 4.73785L9.98642 12.5023C10.2699 12.7416 10.629 12.8729 11 12.8729C11.371 12.8729 11.73 12.7416 12.0136 12.5023L21.2143 4.73785"
              stroke="#4a4a4a"
              strokeWidth="1.71429"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
          </g>
          <defs>
            <clipPath id="clip0_908_383">
              <rect width="22" height="22" fill="white"></rect>
            </clipPath>
          </defs>
        </svg>
      );
    case CLOSEARROW:
      return (
        <svg
          width="13"
          height="9"
          viewBox="0 0 13 9"
          xmlns="http://www.w3.org/2000/svg"
          version="1.1"
          transform="matrix(1,0,0,-1,0,0)"
        >
          <path
            d="M6.03 6.805c.26.26.68.26.94 0l5.335-5.333a.668.668 0 0 0-.943-.943L6.5 5.39 1.638.53a.666.666 0 1 0-.943.942L6.03 6.805z"
            fillRule="evenodd"
          ></path>
        </svg>
      );
    case OPENARROW:
      return (
        <svg width="13" height="9" viewBox="0 0 13 9" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6.03 6.805c.26.26.68.26.94 0l5.335-5.333a.668.668 0 0 0-.943-.943L6.5 5.39 1.638.53a.666.666 0 1 0-.943.942L6.03 6.805z"
            fillRule="evenodd"
          ></path>
        </svg>
      );
    case NEXTARROW:
      return (
        <svg width="20" height="40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M1 1.429 18.571 19a1.372 1.372 0 0 1 0 2L1 38.571"
            stroke="#000"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </svg>
      );
    case EDIT:
      return (
        <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1">
          <g
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <g transform="translate(-255.000000, -76.000000)" stroke="#FFFFFF">
              <g transform="translate(0.000000, 60.000000)">
                <g transform="translate(256.000000, 16.000000)">
                  <polygon points="5.1611 12.8804 0.2121 15.0004 2.3331 10.0504 11.1721 1.2124 14.0001 4.0404"></polygon>
                  <path d="M12.1641,5.876 L9.3361,3.048"></path>
                  <path d="M5.1611,12.8804 L2.3331,10.0504"></path>
                </g>
              </g>
            </g>
          </g>
        </svg>
      );
    case OCCUPIED:
      return (
        <svg height="24" width="24" viewBox="0 0 24 24">
          <path
            d="M.5 7 7 .5 13.5 7M2.5 8.5v5h9v-5"
            transform="scale(1.71429)"
            fill="none"
            stroke="rgb(101, 100, 100)"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </svg>
      );
    case MAP:
      return (
        <svg width="24" height="24" fill="none">
          <path
            d="M12 23.143c6.154 0 11.143-4.989 11.143-11.143C23.143 5.846 18.154.857 12 .857 5.846.857.857 5.846.857 12c0 6.154 4.989 11.143 11.143 11.143Z"
            fill="none"
            stroke="#656464"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="m12.857 18 3.429-10.286L6 11.143l4.286 2.571L12.857 18Z"
            fill="none"
            stroke="#656464"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </svg>
      );
    case FLEXIBLE:
      return (
        <svg width="24" height="24" fill="none">
          <path
            d="M.857 12A11.142 11.142 0 1 0 12 .857a12.394 12.394 0 0 0-8.571 3.429"
            fill="none"
            stroke="#656464"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="m4.286.857-.857 3.429 3.428.857M12 6v6.857l-4.457 2.229"
            fill="none"
            stroke="#656464"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
        </svg>
      );
    case STAR:
      return (
        <svg width="23" height="23" viewBox="0 0 23 23">
          <path
            d="M22.938 8.008c-.15-.412-.544-.69-.985-.69H14.38L12.507.758C12.377.31 11.967 0 11.5 0c-.467 0-.88.31-1.006.76L8.618 7.317H1.046c-.442 0-.833.278-.983.69-.15.414-.025.876.314 1.16l5.7 4.75L3.2 21.59c-.16.43-.02.916.346 1.196.362.28.87.29 1.242.02l6.71-4.79 6.713 4.79c.375.27.88.26 1.245-.02.366-.28.504-.765.343-1.196l-2.875-7.67 5.7-4.75c.34-.284.463-.746.315-1.16"
            fillRule="evenodd"
          ></path>
        </svg>
      );
    case PROFILE:
      return (
        <svg width="22" height="22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M11.003 11a5.107 5.107 0 1 0 0-10.214 5.107 5.107 0 0 0 0 10.214ZM20.714 21.214a10.198 10.198 0 0 0-19.423 0h19.423Z"
            fill="#3C3C3C"
          ></path>
        </svg>
      );
    case LOCATION:
      return (
        <svg width="18" height="18" fill="none">
          <path
            fill="none"
            d="M14.786 6.429C14.786 9.63 9 17.357 9 17.357S3.214 9.63 3.214 6.43a5.786 5.786 0 1 1 11.572 0v0Z"
            stroke="#656464"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <path
            d="M9 8.357A1.929 1.929 0 1 0 9 4.5a1.929 1.929 0 0 0 0 3.857Z"
            stroke="#656464"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          ></path>
        </svg>
      );
    case CHECKED:
      return (
        <svg width="24" height="24" fill="none">
          <g
            clipPath="url(#a)"
            stroke="#f15b26"
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path
              fill="none"
              d="m6.857 13.714 3.514 2.812a.823.823 0 0 0 .686.171.857.857 0 0 0 .583-.411l5.503-9.429"
            ></path>
            <path
              fill="none"
              d="M12 23.143c6.154 0 11.143-4.989 11.143-11.143C23.143 5.846 18.154.857 12 .857 5.846.857.857 5.846.857 12c0 6.154 4.989 11.143 11.143 11.143Z"
            ></path>
          </g>
          <defs>
            <clipPath id="a">
              <path fill="#fff" d="M0 0h24v24H0z"></path>
            </clipPath>
          </defs>
        </svg>
      );
    case SHARE:
      return (
        <svg
          fill="none"
          width="20px"
          height="20px"
          viewBox="0 0 0.375 0.375"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="none"
            d="M0.113 0.188h0.1M0.275 0.1 0.213 0.187 0.275 0.275m0.088 -0.213a0.05 0.05 0 0 1 -0.1 0 0.05 0.05 0 0 1 0.1 0Zm0 0.25a0.05 0.05 0 0 1 -0.1 0 0.05 0.05 0 0 1 0.1 0Zm-0.25 -0.125a0.05 0.05 0 0 1 -0.1 0 0.05 0.05 0 0 1 0.1 0Z"
            stroke="rgb(74, 74, 74)"
            strokeLinecap="square"
            strokeWidth="0.025"
          />
        </svg>
      );
    case LINK:
      return (
        <svg
          width="800px"
          height="800px"
          viewBox="0 0 64 64"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          stroke="#b2b2b2"
        >
          <path fill="none" points="48 28 48 16 36 16" d="M48 28L48 16L36 16" />
          <path x1="48" y1="16" x2="16" y2="48" d="M48 16L16 48" />
        </svg>
      );
    case INSTAGRAM:
      return (
        <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"></path>
        </svg>
      );
    case LINKEDIN:
      return (
        <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"></path>
        </svg>
      );
    case TWITTER:
      return (
        <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"></path>
        </svg>
      );
    case FACEBOOK:
      return (
        <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"></path>
        </svg>
      );
    case SEARCH:
      return (
        <svg
          width="21"
          height="22"
          viewBox="0 0 21 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7 15L1.75887 20.2411"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></path>
          <circle
            fill="none"
            cx="7.5"
            cy="7.5"
            r="7.5"
            transform="matrix(-1 0 0 1 20 1)"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></circle>
        </svg>
      );
    case REVIEW:
      return (
        <svg
          width="35"
          height="35"
          viewBox="0 0 35 35"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.5 0C7.835 0 0 7.835 0 17.5C0 27.165 7.835 35 17.5 35C27.165 35 35 27.165 35 17.5C35 7.835 27.165 0 17.5 0ZM23.3472 11.2682C24.8342 11.2682 26.0395 12.4735 26.0395 13.9605C26.0395 15.4474 24.8342 16.6528 23.3472 16.6528C21.8603 16.6528 20.6549 15.4474 20.6549 13.9605C20.6549 12.4735 21.8603 11.2682 23.3472 11.2682ZM11.6528 11.2682C13.1397 11.2682 14.3451 12.4735 14.3451 13.9605C14.3451 15.4474 13.1397 16.6528 11.6528 16.6528C10.1658 16.6528 8.96046 15.4474 8.96046 13.9605C8.96046 12.4735 10.1658 11.2682 11.6528 11.2682ZM17.5 28.4615C12.9292 28.4615 8.79454 25.5766 7.21138 21.2827L9.37662 20.4844C10.6269 23.8755 13.8915 26.1538 17.5 26.1538C21.1085 26.1538 24.3731 23.8755 25.6234 20.4844L27.7886 21.2827C26.2055 25.5766 22.0708 28.4615 17.5 28.4615Z"
            fill="white"
          ></path>
        </svg>
      );
    case MANAGEMENT:
      return (
        <svg width="39" height="39" viewBox="0 0 100 100">
          <path
            d="M83.332 10H16.667C13 10 10 13.001 10 16.667v53.332c0 3.665 3 6.667 6.667 6.667h29.999v6.666H33.333v6.667h33.333v-6.667H53.334v-6.666h29.998c3.666 0 6.668-3.002 6.668-6.667V16.667C90 13.001 86.998 10 83.332 10zM43.333 50.286l-4.713 4.713-6.953-6.953-6.953 6.953L20 50.286l6.953-6.953L20 36.38l4.713-4.713 6.953 6.953 6.953-6.953 4.713 4.713-6.953 6.953zm19.999 3.736-9.998-10 4.713-4.713 5.285 5.283 11.953-11.95L80 37.356z"
            data-original="#000000"
          ></path>
        </svg>
      );
    case CHAT:
      return (
        <svg
          width="34"
          height="28"
          viewBox="0 0 34 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M34 10.9332V20.523C33.9992 21.2164 33.7234 21.8812 33.2331 22.3715C32.7428 22.8618 32.078 23.1376 31.3846 23.1383H30.5128V26.6255C30.5127 26.7912 30.4654 26.9535 30.3765 27.0933C30.2875 27.2331 30.1606 27.3447 30.0106 27.415C29.8605 27.4853 29.6936 27.5114 29.5292 27.4902C29.3649 27.4691 29.2099 27.4016 29.0826 27.2956L24.0944 23.1383H15.6923C14.9989 23.1376 14.3341 22.8618 13.8438 22.3715C13.3535 21.8812 13.0777 21.2164 13.0769 20.523V19.6512H21.7949C22.9505 19.6498 24.0585 19.1901 24.8756 18.3729C25.6928 17.5558 26.1525 16.4478 26.1538 15.2922V8.31783H31.3846C32.078 8.31859 32.7428 8.59439 33.2331 9.0847C33.7234 9.57502 33.9992 10.2398 34 10.9332ZM21.7949 17.9076H9.99077L5.02049 23.705C4.90457 23.8401 4.75009 23.9364 4.57781 23.9811C4.40553 24.0258 4.22371 24.0166 4.05676 23.9549C3.88982 23.8932 3.74576 23.7819 3.64394 23.6359C3.54212 23.49 3.48741 23.3163 3.48718 23.1383V17.9076H2.61538C1.92198 17.9068 1.25718 17.631 0.766869 17.1407C0.276555 16.6504 0.000761495 15.9856 0 15.2922V3.08706C0.000761495 2.39365 0.276555 1.72886 0.766869 1.23855C1.25718 0.748234 1.92198 0.472441 2.61538 0.47168H21.7949C22.4883 0.472441 23.1531 0.748234 23.6434 1.23855C24.1337 1.72886 24.4095 2.39365 24.4103 3.08706V15.2922C24.4095 15.9856 24.1337 16.6504 23.6434 17.1407C23.1531 17.631 22.4883 17.9068 21.7949 17.9076ZM19.1795 10.9332C19.1795 10.702 19.0876 10.4803 18.9241 10.3168C18.7607 10.1533 18.5389 10.0614 18.3077 10.0614H6.10256C5.87135 10.0614 5.64961 10.1533 5.48611 10.3168C5.32262 10.4803 5.23077 10.702 5.23077 10.9332C5.23077 11.1644 5.32262 11.3862 5.48611 11.5497C5.64961 11.7132 5.87135 11.805 6.10256 11.805H18.3077C18.5389 11.805 18.7607 11.7132 18.9241 11.5497C19.0876 11.3862 19.1795 11.1644 19.1795 10.9332ZM19.1795 6.57424C19.1795 6.34303 19.0876 6.12128 18.9241 5.95779C18.7607 5.7943 18.5389 5.70245 18.3077 5.70245H6.10256C5.87135 5.70245 5.64961 5.7943 5.48611 5.95779C5.32262 6.12128 5.23077 6.34303 5.23077 6.57424C5.23077 6.80546 5.32262 7.0272 5.48611 7.1907C5.64961 7.35419 5.87135 7.44604 6.10256 7.44604H18.3077C18.5389 7.44604 18.7607 7.35419 18.9241 7.1907C19.0876 7.0272 19.1795 6.80546 19.1795 6.57424Z"
            fill="white"
          ></path>
        </svg>
      );
    case QUOTES:
      return (
        <svg
          width="27"
          height="34"
          viewBox="0 0 27 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.97872 0C1.78134 0 0 1.78134 0 3.97872V30.0213C0 32.2187 1.78134 34 3.97872 34H22.7872C24.9846 34 26.766 32.2187 26.766 30.0213V3.97872C26.766 1.78134 24.9846 0 22.7872 0H3.97872ZM6.87234 4.34043C5.474 4.34043 4.34043 5.474 4.34043 6.87234C4.34043 8.27068 5.474 9.40425 6.87234 9.40425C8.27068 9.40425 9.40425 8.27068 9.40425 6.87234C9.40425 5.474 8.27068 4.34043 6.87234 4.34043ZM4.34043 17C4.34043 15.6017 5.474 14.4681 6.87234 14.4681C8.27068 14.4681 9.40425 15.6017 9.40425 17C9.40425 18.3983 8.27068 19.5319 6.87234 19.5319C5.474 19.5319 4.34043 18.3983 4.34043 17ZM6.87234 24.5957C5.474 24.5957 4.34043 25.7293 4.34043 27.1277C4.34043 28.526 5.474 29.6596 6.87234 29.6596C8.27068 29.6596 9.40425 28.526 9.40425 27.1277C9.40425 25.7293 8.27068 24.5957 6.87234 24.5957ZM14.1064 5.78723C13.5071 5.78723 13.0213 6.27306 13.0213 6.87234C13.0213 7.47162 13.5071 7.95745 14.1064 7.95745H22.7872C23.3865 7.95745 23.8723 7.47162 23.8723 6.87234C23.8723 6.27306 23.3865 5.78723 22.7872 5.78723H14.1064ZM13.0213 17C13.0213 16.4007 13.5071 15.9149 14.1064 15.9149H22.7872C23.3865 15.9149 23.8723 16.4007 23.8723 17C23.8723 17.5993 23.3865 18.0851 22.7872 18.0851H14.1064C13.5071 18.0851 13.0213 17.5993 13.0213 17ZM14.1064 26.0426C13.5071 26.0426 13.0213 26.5284 13.0213 27.1277C13.0213 27.7269 13.5071 28.2128 14.1064 28.2128H22.7872C23.3865 28.2128 23.8723 27.7269 23.8723 27.1277C23.8723 26.5284 23.3865 26.0426 22.7872 26.0426H14.1064Z"
            fill="white"
          ></path>
        </svg>
      );
    case MATCHED:
      return (
        <svg
          width="35"
          height="28"
          viewBox="0 0 35 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.6349 14.3045C15.1525 14.3045 18.0042 11.4528 18.0042 7.93519C18.0042 4.41756 15.1525 1.56592 11.6349 1.56592C8.11726 1.56592 5.26562 4.41756 5.26562 7.93519C5.26562 11.4528 8.11726 14.3045 11.6349 14.3045Z"
            fill="white"
          ></path>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.1641 13.5916C15.7321 14.957 13.7827 15.7971 11.635 15.7971C9.48726 15.7971 7.53784 14.957 6.10581 13.5916C5.8592 13.5304 5.61259 13.47 5.37309 13.4394C5.13359 13.4089 4.9019 13.4089 4.68585 13.4423C4.47051 13.475 4.27152 13.5418 4.03913 13.625C3.80673 13.7074 3.54165 13.8069 3.20975 14.0059C2.87857 14.205 2.47988 14.5035 2.09895 15.0017C1.71731 15.4986 1.35273 16.1958 1.02084 17.0253C0.688946 17.8541 0.390458 18.8165 0.224867 19.7455C0.0592772 20.6737 0.0258748 21.57 0.00952903 22.2495C-0.00752747 22.9297 -0.00752747 23.3946 0.0592772 23.8424C0.125371 24.2902 0.257559 24.7209 0.556758 25.1523C0.855247 25.5838 1.31933 26.0152 1.86656 26.3465C2.41378 26.6784 3.04416 26.9108 3.90694 27.0267C4.769 27.1425 5.86346 27.1425 7.19032 27.1425H11.038H11.635H12.2319H16.0796C17.4064 27.1425 18.5009 27.1425 19.363 27.0267C20.2257 26.9108 20.8561 26.6784 21.4034 26.3465C21.9506 26.0152 22.4147 25.5838 22.7132 25.1523C23.0124 24.7209 23.1445 24.2902 23.2106 23.8424C23.2774 23.3946 23.2774 22.9297 23.2604 22.2495C23.244 21.57 23.2106 20.6737 23.045 19.7455C22.8795 18.8165 22.581 17.8541 22.2491 17.0253C21.9172 16.1958 21.5526 15.4986 21.171 15.0017C20.79 14.5035 20.3913 14.205 20.0602 14.0059C19.7283 13.8069 19.4632 13.7074 19.2308 13.625C18.9984 13.5418 18.7994 13.475 18.5841 13.4423C18.368 13.4089 18.1363 13.4089 17.8968 13.4394C17.6573 13.47 17.4107 13.5304 17.1641 13.5916Z"
            fill="white"
          ></path>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.4239 11.0739C19.5558 12.1074 21.063 12.7385 22.7166 12.7385C26.2333 12.7385 29.0843 9.88691 29.0843 6.36927C29.0843 2.85164 26.2333 0 22.7166 0C20.4583 0 18.4736 1.17634 17.3438 2.94973C18.6186 4.11398 19.4187 5.79141 19.4187 7.65436C19.4187 8.91243 19.0535 10.0866 18.4239 11.0739Z"
            fill="white"
          ></path>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M27.8933 12.2609C26.5034 13.585 24.6271 14.4159 22.5547 14.4643L22.7836 14.7386C23.1654 15.2355 23.5301 15.9327 23.8621 16.7622C24.1942 17.591 24.4928 18.5534 24.6584 19.4824C24.8241 20.4106 24.8575 21.3069 24.8738 21.9864C24.8909 22.6666 24.8909 23.1315 24.8241 23.5793C24.758 24.0271 24.6257 24.4578 24.3264 24.8892C24.1039 25.2105 23.7896 25.5325 23.4178 25.8118H26.8084C28.1357 25.8118 29.2306 25.8118 30.093 25.696C30.9561 25.5801 31.5867 25.3477 32.1342 25.0158C32.6816 24.6845 33.1459 24.2531 33.4445 23.8217C33.7438 23.3902 33.876 22.9595 33.9421 22.5117C34.009 22.0639 34.009 21.5991 33.9919 20.9188C33.9755 20.2393 33.9421 19.343 33.7765 18.4148C33.6108 17.4858 33.3122 16.5234 32.9802 15.6946C32.6482 14.8652 32.2835 14.1679 31.9017 13.671C31.5206 13.1728 31.1218 12.8743 30.7904 12.6752C30.4584 12.4762 30.1932 12.3767 29.9608 12.2943C29.7283 12.2111 29.5292 12.1443 29.3138 12.1116C29.0976 12.0782 28.8659 12.0782 28.6263 12.1088C28.3867 12.1393 28.14 12.1997 27.8933 12.2609Z"
            fill="white"
          ></path>
        </svg>
      );
    case PROJECT:
      return (
        <svg
          fill="white"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 30 30"
          width="35"
          height="35"
        >
          <path d="M 5 4 C 3.895 4 3 4.895 3 6 L 3 9 L 3 11 L 22 11 L 27 11 L 27 8 C 27 6.895 26.105 6 25 6 L 12.199219 6 L 11.582031 4.9707031 C 11.221031 4.3687031 10.570187 4 9.8671875 4 L 5 4 z M 2.5019531 13 C 1.4929531 13 0.77040625 13.977406 1.0664062 14.941406 L 4.0351562 24.587891 C 4.2941563 25.426891 5.0692656 26 5.9472656 26 L 15 26 L 24.052734 26 C 24.930734 26 25.705844 25.426891 25.964844 24.587891 L 28.933594 14.941406 C 29.229594 13.977406 28.507047 13 27.498047 13 L 15 13 L 2.5019531 13 z"></path>
        </svg>
      );
    case BRAND_AMEX:
      return (
        <svg
          className={classes}
          height="16"
          viewBox="0 0 24 16"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none" fillRule="evenodd">
            <rect fill="#016fd0" height="16" rx="2" width="24" />
            <path
              d="M13.764 13.3939V7.6925l10.1476.009v1.575l-1.1729 1.2534 1.1729 1.2648v1.6083H22.039l-.9952-1.0981-.9881 1.1023z"
              fill="#fffffe"
            />
            <path
              d="M14.4418 12.7688V8.3199h3.7723v1.0249h-2.5509v.6957h2.49v1.0078h-2.49v.6833h2.5509v1.0372z"
              fill="#016fd0"
            />
            <path
              d="M18.1953 12.7688l2.0873-2.227L18.1952 8.32h1.6156l1.2755 1.41 1.2791-1.41h1.5462v.035l-2.0429 2.1868 2.0429 2.1639v.0631h-1.5617l-1.2981-1.4242-1.2848 1.4242z"
              fill="#016fd0"
            />
            <path
              d="M14.2373 2.632h2.4461l.8591 1.9508V2.632h3.0199l.5207 1.4615.5226-1.4615h2.3059v5.7013H11.7251z"
              fill="#fffffe"
            />
            <g fill="#016fd0">
              <path d="M14.7005 3.2514l-1.974 4.4451h1.3539l.3724-.8901h2.018l.372.8901h1.3877l-1.9658-4.4451zm.1696 2.5574l.592-1.415.5916 1.415z" />
              <path d="M18.212 7.6957v-4.445l1.903.0065.9794 2.7327.9856-2.7392h1.8316v4.445l-1.1786.0105V4.6528l-1.1126 3.043h-1.0758L19.409 4.6423v3.0533z" />
            </g>
          </g>
        </svg>
      );
    case INFO:
      return (
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.49992 0.583374C4.12992 0.583374 0.583252 4.13004 0.583252 8.50004C0.583252 12.87 4.12992 16.4167 8.49992 16.4167C12.8699 16.4167 16.4166 12.87 16.4166 8.50004C16.4166 4.13004 12.8699 0.583374 8.49992 0.583374ZM9.29158 12.4584H7.70825V7.70837H9.29158V12.4584ZM9.29158 6.12504H7.70825V4.54171H9.29158V6.12504Z"
            fill="#F15B26"
          />
        </svg>
      );
    case BRAND_DINERS:
      return (
        <svg
          className={classes}
          width="24"
          height="16"
          viewBox="0 0 24 16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fillRule="nonzero" fill="none">
            <path
              d="M21.9972 15.75h.0022c.955.0081 1.7387-.7727 1.7506-1.7458V2.0063c-.0038-.4706-.1911-.9201-.5203-1.2495a1.7197 1.7197 0 0 0-1.2325-.5067H2.0006C1.5411.246 1.0986.4283.7703.7568.441 1.0862.2538 1.5357.25 2.0043v11.9894c.0038.4706.1911.9201.5203 1.2495a1.7197 1.7197 0 0 0 1.2325.5067h19.9944zm-.001.5h-.0011.0021-.001z"
              strokeOpacity=".2"
              stroke="#000"
              strokeWidth=".5"
              fill="#FFF"
            />
            <path
              d="M10.0021 2.0518v-.016h4v.016c3.1354.2294 5.5621 2.8402 5.5621 5.984s-2.4267 5.7546-5.562 5.984v.016h-4v-.016C6.8666 13.7904 4.44 11.1796 4.44 8.0358s2.4267-5.7546 5.5621-5.984z"
              fill="#0165AC"
            />
            <path
              d="M11.6021 11.4278a3.6 3.6 0 0 0 0-6.784v6.784zm-2.4-6.784a3.6 3.6 0 0 0 0 6.784v-6.784zm1.2 8.592c-2.8719 0-5.2-2.3281-5.2-5.2s2.3281-5.2 5.2-5.2 5.2 2.3281 5.2 5.2-2.3281 5.2-5.2 5.2z"
              fill="#FFF"
            />
          </g>
        </svg>
      );
    case BRAND_DISCOVERY:
      return (
        <svg
          className={classes}
          width="24"
          height="16"
          viewBox="0 0 24 16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fillRule="nonzero" fill="none">
            <path
              d="M21.9972 15.75h.0022c.955.0081 1.7387-.7727 1.7506-1.7458V2.0063c-.0038-.4706-.1911-.9201-.5203-1.2495a1.7197 1.7197 0 0 0-1.2325-.5067H2.0006C1.5411.246 1.0986.4283.7703.7568.441 1.0862.2538 1.5357.25 2.0043v11.9894c.0038.4706.1911.9201.5203 1.2495a1.7197 1.7197 0 0 0 1.2325.5067h19.9944zm-.001.5h-.0011.0021-.001z"
              strokeOpacity=".2"
              stroke="#000"
              strokeWidth=".5"
              fill="#FFF"
            />
            <path
              d="M12.6124 16h9.3848A1.9862 1.9862 0 0 0 24 14.0302v-2.3586a38.7393 38.7393 0 0 1-11.3876 4.3282z"
              fill="#F27712"
            />
            <path
              d="M23.1724 9.2965H22.32l-.96-1.2662h-.091v1.2662h-.6952V6.1517H21.6c.8028 0 1.2662.331 1.2662.9268 0 .4883-.2896.8028-.811.9021l1.1172 1.3159zm-1.0262-2.1931c0-.3062-.2317-.4635-.662-.4635h-.2152v.9518h.1986c.4469 0 .6786-.1656.6786-.4883zm-4.0055-.9517h1.9696v.5296H18.836v.7035h1.2248v.5379h-1.2248v.8524h1.2744v.5297h-1.9696V6.1517zm-2.2345 3.2275L14.4 6.1434h.7614l.9517 2.1186.96-2.1186h.7448l-1.5227 3.2358h-.389zm-6.298-.0082c-1.0592 0-1.8868-.72-1.8868-1.6552 0-.9104.8441-1.647 1.9034-1.647.298 0 .5462.058.8524.1904v.7283a1.2414 1.2414 0 0 0-.869-.3558c-.662 0-1.1668.48-1.1668 1.084 0 .6373.4965 1.0925 1.2 1.0925.3145 0 .5545-.0993.8358-.3476v.7283c-.3144.1324-.5793.182-.869.182zm-2.102-1.0345c0 .6124-.5048 1.0345-1.2331 1.0345-.5297 0-.9103-.1821-1.2331-.5959l.4552-.389c.1572.2814.422.4221.753.4221.3146 0 .538-.1903.538-.4386 0-.1407-.0662-.2483-.2069-.331a2.88 2.88 0 0 0-.48-.1821c-.6538-.207-.8772-.4304-.8772-.869 0-.513.48-.902 1.109-.902.3972 0 .753.124 1.051.3558l-.3642.4138a.7614.7614 0 0 0-.5627-.2483c-.298 0-.5131.149-.5131.3476 0 .1655.1241.2566.5379.3973.7945.2482 1.0262.48 1.0262.993v-.0082zm-3.418-2.1848h.6952v3.153h-.6951v-3.153zm-2.2344 3.153H.8276v-3.153h1.0262c1.1255 0 1.9034.6455 1.9034 1.5724 0 .4717-.2317.9186-.6372 1.2165-.3476.2483-.7366.3642-1.2745.3642h.0083zm.811-2.3668c-.2317-.1821-.4965-.2483-.9517-.2483h-.1903V8.775h.1903c.4469 0 .7283-.0828.9517-.2483.24-.1986.3807-.4965.3807-.8027 0-.3062-.1407-.5959-.3807-.7862z"
              fill="#000"
            />
            <path
              d="M12.4138 6.0689c-.9104 0-1.6552.7283-1.6552 1.6303 0 .96.7117 1.68 1.6552 1.68.9269 0 1.6552-.7282 1.6552-1.6551 0-.927-.72-1.6552-1.6552-1.6552z"
              fill="#F27712"
            />
          </g>
        </svg>
      );
    case BRAND_JCB:
      return (
        <svg
          className={classes}
          height="16"
          viewBox="0 0 23 16"
          width="23"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none">
            <path
              d="M.2054 16h4.5178c1.0278 0 2.259-1.1947 2.259-2.1333V0h-4.518C1.4366 0 .2055 1.1947.2055 3.2z"
              fill="#047ab1"
            />
            <path
              d="M2.7692 10.816a9.7709 9.7709 0 0 1-2.5638-.3413V9.3013c.6467.3777 1.386.5909 2.146.6187.8696 0 1.3553-.576 1.3553-1.3653V5.3333h2.146v3.2214c0 1.2586-.7003 2.2613-3.0835 2.2613z"
              fill="#fff"
            />
            <path
              d="M8.1116 16h4.5179c1.0278 0 2.2589-1.1947 2.2589-2.1333V0h-4.5179C9.3427 0 8.1116 1.1947 8.1116 3.2z"
              fill="#d42d06"
            />
            <path
              d="M8.1116 6.08c.6551-.5973 1.7846-.9707 3.6143-.8853.994.0426 2.033.32 2.033.32v1.184c-.5943-.3395-1.2623-.5474-1.954-.608C10.4158 5.9733 9.5687 6.7093 9.5687 8s.8471 2.0267 2.2364 1.92c.692-.066 1.3596-.2774 1.954-.6187v1.1734s-1.0392.288-2.0331.3306c-1.8297.0854-2.9592-.288-3.6143-.8853z"
              fill="#fff"
            />
            <path
              d="M16.0179 16h4.5178c1.0278 0 2.259-1.1947 2.259-2.1333V0h-4.518C17.249 0 16.018 1.1947 16.018 3.2z"
              fill="#67b637"
            />
            <path
              d="M21.6652 9.28c0 .8533-.7003 1.3867-1.6377 1.3867h-4.0096V5.3333h3.6481l.2598.0107c.8245.0427 1.4344.5013 1.4344 1.2907 0 .6186-.4179 1.152-1.1746 1.28v.032c.8358.0533 1.4796.5546 1.4796 1.3333zM18.785 6.176a1.0871 1.0871 0 0 0-.1468-.0107H17.283v1.344h1.5021c.2824-.064.5196-.3093.5196-.672 0-.3626-.2372-.608-.5196-.6613zm.1695 2.176a1.0276 1.0276 0 0 0-.1808-.0107H17.283v1.4614h1.4908l.1808-.0214c.2823-.064.5195-.3413.5195-.7146 0-.3734-.2259-.64-.5195-.7147z"
              fill="#fff"
            />
          </g>
        </svg>
      );
    case BRAND_MASTERCARD:
      return (
        <svg
          className={classes}
          height="16"
          viewBox="0 0 24 16"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none" fillRule="evenodd">
            <rect fill="#252525" height="16" rx="2" width="24" />
            <circle cx="9" cy="8" fill="#eb001b" r="5" />
            <circle cx="15" cy="8" fill="#f79e1b" r="5" />
            <path
              d="M12 3.9996c1.2144.9122 2 2.3646 2 4.0004s-.7856 3.0882-2 4.0004C10.7856 11.0882 10 9.6358 10 8s.7856-3.0882 2-4.0004z"
              fill="#ff5f00"
            />
          </g>
        </svg>
      );
    case BRAND_UNIONPAY:
      return (
        <svg
          className={classes}
          height="16"
          viewBox="0 0 24 16"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none">
            <path
              d="M4.5459 0h5.7938c.8087 0 1.3117.7257 1.123 1.619L8.7655 14.3675c-.1904.8902-1.0002 1.6165-1.8095 1.6165H1.1627c-.8076 0-1.3118-.7263-1.1231-1.6165L2.7381 1.619C2.9268.7257 3.7361 0 4.546 0"
              fill="#dd2423"
            />
            <path
              d="M9.8576 0h6.6627c.8086 0 .444.7257.2537 1.619l-2.697 12.7485c-.1892.8902-.1302 1.6165-.9405 1.6165H6.4738c-.8103 0-1.3118-.7263-1.1214-1.6165L8.0493 1.619C8.2408.7257 9.0483 0 9.8576 0"
              fill="#16315e"
            />
            <path
              d="M16.256 0h5.7938c.8098 0 1.3129.7257 1.1226 1.619l-2.697 12.7485c-.1903.8902-1.0006 1.6165-1.8104 1.6165h-5.791c-.8104 0-1.313-.7263-1.1232-1.6165L14.4482 1.619C14.637.7257 15.4457 0 16.256 0"
              fill="#036862"
            />
            <path
              d="M6.059 4.0856c-.5958.0067-.7717 0-.828-.0146-.0216.113-.4236 2.1546-.4247 2.1563-.0866.413-.1496.7075-.3635.8976-.1215.1105-.2633.1639-.4276.1639-.2643 0-.4182-.1445-.444-.4184l-.005-.094s.0805-.5533.0805-.5564c0 0 .422-1.8605.4975-2.1064a.1945.1945 0 0 0 .0061-.028c-.8213.008-.967 0-.977-.0146-.0055.02-.0258.1354-.0258.1354l-.4308 2.097-.037.1778-.0716.5817c0 .1725.0307.3134.092.4325.1963.3776.7563.4342 1.073.4342.4081 0 .791-.0955 1.0497-.2698.449-.292.5666-.7486.6713-1.1544l.0486-.2081s.4347-1.9323.5085-2.1837c.0029-.014.004-.0213.0078-.028zm1.479 1.5588c-.1048 0-.2963.028-.4683.1208-.0624.0353-.1215.076-.1838.1166l.0562-.2234-.0307-.0376c-.3648.0813-.4464.0922-.7834.1444l-.0282.0207c-.0391.357-.0739.6255-.219 1.3274a90.3116 90.3116 0 0 1-.17.778l.0156.0327c.3453-.02.45-.02.7502-.0146l.0242-.029c.0382-.215.0431-.2654.1276-.7009.0396-.2064.1224-.66.1632-.8215.075-.0383.149-.0759.2196-.0759.1682 0 .1477.1615.1412.2259-.0072.108-.0685.4609-.1313.7639l-.042.1955c-.0292.1445-.0612.2848-.0905.428l.0127.0286c.3404-.02.4442-.02.7348-.0146l.0342-.029c.0525-.3358.0679-.4257.1611-.9146l.0469-.2246c.091-.4397.1368-.6626.068-.8442-.073-.2035-.2478-.2526-.4083-.2526zm1.6521.4603c-.181.0383-.2963.0637-.411.0802-.1136.02-.2245.0383-.3993.065l-.0139.0138-.0127.011c-.0182.1434-.0309.2673-.055.413-.0205.1506-.052.3218-.1033.5677-.0397.1882-.0601.2538-.0827.32-.022.0663-.0463.1307-.091.3158l.0105.0171.0087.0157c.1634-.0085.2703-.0146.3802-.0157.1097-.0043.2234 0 .3994.001l.0154-.0137.0165-.0153c.0254-.167.0292-.2119.0447-.2933.0154-.0874.042-.2083.107-.5314.0309-.1517.0652-.303.0971-.4578.0332-.1542.068-.306.101-.4578l-.005-.0183zm.0039-.6206c-.1644-.1068-.453-.0729-.6471.0746-.1936.1446-.2157.3498-.0518.458.1615.1038.4512.0729.6436-.0759.1932-.1477.2174-.351.0553-.4567zm.994 2.4734c.3326 0 .6735-.101.9301-.4003.1974-.2428.288-.6041.3193-.7529.1021-.4931.0226-.7233-.0772-.8635-.1517-.2138-.4197-.2824-.6978-.2824-.1672 0-.5654.0182-.8765.334-.2234.2277-.3267.5368-.389.833-.0628.302-.135.8454.319 1.0477.14.0662.342.0844.4722.0844zm-.026-1.1095c.0768-.3734.1673-.6868.3983-.6868.181 0 .1942.2332.1137.6078-.0144.0832-.0805.3924-.1699.524-.0624.0972-.1363.1561-.2179.1561-.0243 0-.1688 0-.171-.2361-.0011-.1166.0205-.2357.0469-.365zm2.1068 1.0615l.026-.0291c.0368-.215.0429-.2655.1245-.7008.0408-.2065.1253-.66.165-.8216.075-.0384.1478-.076.2207-.076.167 0 .1467.1615.14.2259-.006.1082-.0673.4609-.1313.7639l-.0396.1955c-.0304.1446-.0635.2848-.0927.4282l.0127.0286c.3415-.02.4413-.02.7337-.0146l.0353-.0291c.0512-.336.065-.4258.161-.9146l.0458-.2247c.0916-.4397.1379-.6624.07-.844-.0749-.2035-.2509-.2526-.4092-.2526-.1049 0-.2974.0278-.4684.1208a3.0577 3.0577 0 0 0-.1826.1166l.0524-.2234-.028-.0378c-.3647.0814-.448.0923-.7846.1446l-.0258.0206c-.0408.3571-.074.6254-.219 1.3275a95.9633 95.9633 0 0 1-.17.7779l.0155.0328c.3458-.02.449-.02.7486-.0146zm2.5088.0145c.0215-.1154.149-.799.1501-.799 0 0 .1086-.5017.1152-.5199 0 0 .0342-.0522.0684-.0729h.0503c.4743 0 1.01 0 1.4298-.34.2857-.2332.481-.5775.5681-.996a1.6492 1.6492 0 0 0 .0393-.3466c0-.1603-.0292-.3189-.1137-.4428-.214-.3297-.6404-.3358-1.1326-.3383l-.2426.0025c-.63.0086-.8826.0061-.9864-.0079-.0088.0505-.0253.1404-.0253.1404s-.2256 1.1513-.2256 1.1531l-.5655 2.5632c.55-.0073.7756-.0073.8705.0042zm.4181-2.0452s.24-1.149.2388-1.1446l.0078-.059.0034-.0448.0959.0108s.4948.0468.5064.048c.1953.0832.2758.2976.2196.5774-.0513.2558-.202.4708-.3956.5746-.1594.088-.3547.0953-.556.0953h-.1301zm1.494.9905c-.0635.2975-.1364.841.3154 1.0347.144.0674.2731.0875.4043.0802.1385-.0082.2669-.0847.3858-.1948l-.0322.1359.0205.029c.325-.015.4258-.015.7778-.012l.032-.0268c.0513-.3327.0998-.6557.2334-1.2922.065-.3048.13-.6067.1968-.9103l-.0104-.0334c-.3635.0741-.4607.09-.8103.1445l-.0266.0238c-.0035.031-.0072.0607-.0106.0904-.0543-.0967-.1331-.1793-.2547-.2307-.1555-.0674-.5207.0194-.8346.334-.2206.2247-.3265.5325-.3867.8277zm.7633.0182c.0778-.3668.1672-.677.3988-.677.1465 0 .2236.1487.208.4024-.0125.0633-.026.13-.0419.2054-.0232.109-.0483.217-.0727.3252-.0249.074-.0538.1438-.0856.1903-.0596.093-.2014.1506-.283.1506-.0232 0-.166 0-.171-.232-.0011-.1154.0205-.2344.0474-.365zm3.9867-1.2109l-.0281-.0353c-.3597.0802-.4248.093-.7552.1421l-.0243.0267c-.0012.0044-.0021.011-.0038.0171l-.0012-.006c-.246.6248-.2388.49-.439.9818-.0011-.0224-.0011-.0363-.0023-.0601l-.0501-1.0663-.0315-.0353c-.3768.0802-.3857.093-.7336.1421l-.0271.0267c-.0039.0128-.0039.0268-.0061.042l.0022.0055c.0435.2446.033.19.0767.5762.0204.1895.0475.3801.0678.5673.0343.3132.0535.4674.0955.9455-.235.4268-.2907.5884-.5169.963l.0016.0037-.1593.2774c-.0182.0292-.0348.0492-.058.0578-.0253.0138-.0584.0163-.1043.0163h-.0882l-.1312.4804.45.0085c.2642-.0012.4303-.1372.5197-.32l.283-.5339h-.0045l.0298-.0376c.1904-.4511 1.6384-3.1856 1.6384-3.1856zm-4.7501 6.3088h-.191l.7067-2.573h.2344l.0745-.265.0072.2947c-.0088.1822.1214.3437.4634.317h.3956l.1361-.4954h-.1488c-.0856 0-.1253-.0238-.1203-.0748l-.0072-.2999h-.7325v.0016c-.2369.0054-.944.025-1.0873.067-.1732.049-.3558.1937-.3558.1937l.0717-.2654h-.6852l-.1428.5265-.716 2.6123h-.139l-.1363.4919h1.3647l-.0457.164h.6724l.0447-.164h.1886zm-.56-2.0502c-.1097.0334-.3139.1348-.3139.1348l.1816-.6576h.5444l-.1313.4791s-.1682.011-.2807.0437zm.0105.9394s-.171.0237-.2836.0516c-.1108.037-.3187.1536-.3187.1536l.1876-.6843h.5472zm-.305 1.1168h-.5461l.1583-.5775h.5444zm1.315-1.5959h.7872l-.113.4033h-.7977l-.1197.4408h.6979l-.5285.8191c-.037.0602-.0702.0815-.107.0984-.037.0207-.0856.045-.1418.045h-.1936l-.133.4828h.5064c.2632 0 .4187-.1318.5335-.3048l.3624-.546.0778.5544c.0165.1038.0843.1646.1302.1882.0507.028.103.076.177.0832.0794.0037.1368.0067.1749.0067h.2488l.1494-.5404h-.0981c-.0564 0-.1534-.0104-.1699-.0298-.0165-.0237-.0165-.06-.0254-.1154l-.079-.5556h-.3232l.1418-.1858h.796l.1225-.4408h-.737l.1148-.4033h.7347l.1363-.4973h-2.1906zm-6.6482 1.7082l.1837-.6728h.7551l.138-.5004h-.7558l.1153-.4141h.7386l.1369-.4846h-1.848l-.134.4846h.4198l-.112.414h-.421l-.1395.509h.4197l-.2449.8902c-.033.1178.0156.1627.0464.2175.0315.0533.0634.0886.1351.1086.074.0182.1247.0291.1936.0291h.8513l.1517-.5544-.3774.0571c-.0729 0-.2747-.0096-.2526-.0838zm.0866-3.2208l-.1914.3807c-.041.0831-.0778.1348-.111.1585-.0292.02-.0871.0285-.171.0285h-.0998l-.1335.487h.3316c.1594 0 .2819-.0643.3403-.0965.0629-.037.0794-.0159.128-.0675l.112-.1068h1.0354l.1374-.507h-.758l.1324-.277zm1.5286 3.2306c-.0177-.028-.005-.0773.022-.1799l.283-1.0311h1.0068c.1467-.0023.2526-.0042.3215-.0096.074-.0086.1545-.0377.2422-.0899.0905-.0547.1369-.1124.176-.1786.0436-.066.1137-.2107.1738-.4336l.3557-1.3049-1.0447.0067s-.3217.0522-.4633.11c-.143.0643-.3471.244-.3471.244l.0943-.3577h-.6454l-.9035 3.2986c-.032.128-.0535.221-.0585.2769-.0017.0601.069.1197.1147.1646.054.0449.134.0376.2107.0449.0806.0067.1953.0109.3536.0109h.496l.1522-.5659-.444.0462a.1138.1138 0 0 1-.096-.0516zm.4876-1.9074h1.0575l-.0673.2319c-.0094.0054-.032-.0115-.1396.0025h-.9157zm.2118-.778h1.0664l-.0767.2794s-.5026-.0054-.583.0109c-.3543.0675-.5611.2758-.5611.2758zm.8021 1.7866c-.0087.0347-.0226.0558-.042.0717-.0214.0152-.0561.0206-.108.0206h-.1506l.0089-.2824H12.7l-.0254 1.3809c-.001.0996.0078.1573.074.2035.0662.0576.2703.065.545.065h.3927l.1418-.517-.342.0207-.1136.0073c-.0155-.0073-.0304-.014-.0469-.0321-.0144-.0157-.0387-.0061-.0347-.1057l.0027-.354.3585-.0163c.1936 0 .2764-.0694.347-.1354.0674-.0633.0894-.136.1148-.2345l.0602-.3134h-.4927z"
              fill="#fefefe"
            />
          </g>
        </svg>
      );
    case BRAND_VISA:
      return (
        <svg
          className={classes}
          width="24"
          height="16"
          viewBox="0 0 24 16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fillRule="nonzero" fill="none">
            <rect
              strokeOpacity=".2"
              stroke="#000"
              strokeWidth=".5"
              fill="#FFF"
              x=".25"
              y=".25"
              width="23.5"
              height="15.5"
              rx="2"
            />
            <path
              d="M2.78773262 5.91443732C2.26459089 5.62750595 1.6675389 5.39673777 1 5.23659312l.0280005-.12471102h2.73697872c.37098332.01300346.67201191.12462375.76996714.51882925l.59482061 2.83587917.18221641.85413565L6.97796639 5.1118821h1.79882257l-2.67390785 6.1656463H4.30396552l-1.5162329-5.36309108zm7.31224258 5.36963648H8.39882877l1.06401886-6.1721917H11.163901l-1.0639258 6.1721917zm6.1668069-6.02129922l-.2313529 1.3328108-.1538632-.06554092c-.3078194-.12479829-.7141522-.2495093-1.2671852-.2363313-.6716398 0-.9728545.26905813-.9798314.53174543 0 .28895604.3643786.47938251.9593659.76179318.9801104.43993579 1.4347231.97831385 1.4279323 1.68093694-.0137677 1.28044789-1.1758348 2.10786929-2.9607967 2.10786929-.7631763-.0066327-1.4982591-.1579615-1.8972429-.3284901l.2380507-1.38552277.224004.09861682c.5530331.23004776.9169465.32831555 1.5961213.32831555.4897761 0 1.0149017-.19060107 1.0215995-.60409358 0-.26923267-.2237249-.46637906-.8818761-.76842582-.6439184-.29558867-1.5048639-.78797464-1.4909101-1.67447884C11.8780532 5.84042483 13.0610509 5 14.7409877 5c.6580581 0 1.1902536.13788902 1.5257944.26277458zm2.2609703 3.83471102h1.4139786c-.0699548-.30859213-.3921-1.78601186-.3921-1.78601186l-.1188858-.5318327c-.0840015.22978594-.2308878.60409353-.2238179.59091553 0 0-.5390794 1.3723448-.6791749 1.72692903zm2.0998512-3.9856035L22 11.2839865h-1.5750977s-.1541422-.7091684-.2029803-.9258637h-2.1841317c-.0631639.1640705-.3570296.9258637-.3570296.9258637h-1.7849619l2.5268355-5.65999506c.1750729-.40057632.4833574-.51210934.889132-.51210934h1.3158373z"
              fill="#171E6C"
            />
          </g>
        </svg>
      );
    default:
      return (
        <svg
          className={classes}
          width="29"
          height="19"
          viewBox="0 0 29 19"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none" fillRule="evenodd">
            <path
              d="M26.58 19H2.42A2.4004 2.4004 0 0 1 0 16.62V2.38A2.4 2.4 0 0 1 2.42 0h24.16A2.4004 2.4004 0 0 1 29 2.38v14.25c-.0165 1.3216-1.0984 2.3811-2.42 2.37zM10 5.83c0-.46-.35-.83-.78-.83H3.78c-.43 0-.78.37-.78.83v3.34c0 .46.35.83.78.83h5.44c.43 0 .78-.37.78-.83V5.83z"
              fill="#DADDE2"
            />
            <path
              d="M25 15h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0H4c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1z"
              fill="#B2B6C1"
            />
          </g>
        </svg>
      );
  }
};

IconCard.defaultProps = {
  className: null,
  rootClassName: null,
  brand: 'default',
};

IconCard.propTypes = {
  className: string,
  rootClassName: string,
  brand: string,
};

export default IconCard;
